<template>
    <div
        class="editorTextElement"
        @mousedown="mousedown"
        @mouseup="mouseup"
        :style="{fontWeight: el.font.weight.value, fontStyle: el.font.weight.style, fontFamily: el.font.family, textAlign: el.font.align, fontSize: fontSizeRecalculate, color: el.color.rgb}"
        :class="{ textCapitals: el.font.capitals, textUnderline: el.font.underline, cursor: el.font.isEdited }"
    >
        <span v-if="hasError" :class="this.el.isActive ? 'visibleError' : ''">{{ errorMessage }}</span>
        <div>
            <textarea
                v-model="content"
                ref="editableComponent"
                spellcheck="false"
                tabindex="2"
                :style="{fontWeight: el.font.weight.value, fontStyle: el.font.weight.style, fontFamily: el.font.family, textAlign: el.font.align, color: el.color.rgb, fontSize: 'inherit', textDecoration: 'inherit', textTransform: 'inherit'}"
                @input="updateContent"
            />
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { messenger, handlers as messengerHandlers } from '../../../js/messenger';
    import Modal from '../../Global/Modal.vue';

    export default {
        data() {
            return {
                content: null,
                start: 0,
                longpress: 300,
                hasError: false,
                errorMessage: null
            }
        },
        directives: {
            focus: {
                inserted: function(el) {
                    el.focus();
                }
            }
        },
        methods: {
            mousedown() {
                this.start = new Date().getTime();
            },
            mouseup() {
                if (new Date().getTime() < (this.start + this.longpress)) {
                    this.editContent(true);
                }
            },
            editContent(boolean) {
                // this.$nextTick(() => {
                //     this.$refs.editableComponent.focus();
                // });
                
                let payload = {
                    variableName: 'isEdited',
                    value: boolean
                }
                this.$store.dispatch('SET_TEXT_VARIABLE', payload)
            },
            updateContent: function(e) {
                this.$nextTick(() => {
                    this.$refs.editableComponent.focus();
                });

                if (this.el.placeholder.hasPlaceholder) {
                    const placeholderElementsIds = this.getPlaceholderUserInputs.find(placeholder => placeholder.placeholderObj.placeholderId === this.el.placeholder.placeholderId).ids;

                    placeholderElementsIds.forEach(el => {
                        let textPayload = {
                            id: el,
                            content: this.content,
                            contentFromPlaceholder: true
                        }
                        this.$store.dispatch('CHANGE_TEXT', textPayload);
                    });

                    this.validateTextField();
                } else {
                    let payload = {
                        id: this.el.id,
                        content: this.content
                    }

                    this.$store.dispatch('CHANGE_TEXT', payload);
                }
            },
            validateTextField() {
                const that = this;
                messenger.validatePlaceholderField({
                    'systemName': this.el.placeholder.placeholderSystemName,
                    'value': this.content,
                }).then(function (result) {
                    if (result.isValid === false) {
                        if (that.hasError === false) {
                            that.hasError = true;
                            that.errorMessage = result.message;
                            that.$parent.$parent.$refs.moveable.moveable.innerMoveable.moveable.moveable.controlBox.element.classList.add('hasError');
                        } else {
                            if (that.errorMessage !== result.message) {
                                that.errorMessage = result.message;
                            }
                        }
                    } else {
                        that.hasError = false;
                        that.errorMessage = null;
                        that.$parent.$parent.$refs.moveable.moveable.innerMoveable.moveable.moveable.controlBox.element.classList.remove('hasError');
                    }
                    that.setContentFromValidation(result.systemName, result.value);
                    console.log('Field Success!', result);
                }, function (error) {
                    console.log('Field Error!', error);
                });
            },
            setContentFromValidation(placeholderSystemName, content) {
                const elementsWithPlaceholder = this.getAllElements.filter(el => Object.keys(el).includes('placeholder')).filter(el => el.placeholder.hasPlaceholder).filter(el => el.placeholder.placeholderSystemName === placeholderSystemName);
                
                elementsWithPlaceholder.forEach(el => {
                    let textPayload = {
                        id: el.id,
                        content,
                        contentFromPlaceholder: true
                    }
                    this.$store.dispatch('CHANGE_TEXT', textPayload);
                });

                this.$nextTick(() => {
                    this.$refs.editableComponent.focus();
                });
            }
        },
        computed: {
            ...mapGetters([
                'activeElement',
                'getSessionDetails',
                'getPlaceholderUserInputs',
                'getPageWebSize',
                'getTemplateFormat',
                'getAllElements'
            ]),
            isActive() {
                return this.el.isActive;
            },
            isEdited() {
                return this.el.font.isEdited;
            },
            isPlaceholder() {
                return this.el.placeholder.hasPlaceholder;
            },
            fontSizeRecalculate() {
                const pageHeightInPt = (this.getTemplateFormat.pageHeight + 2 * this.getTemplateFormat.pageBleed) * 2.84528;
                const ratioInPrint = pageHeightInPt / this.el.font.size;

                return `${this.getPageWebSize.px.height / ratioInPrint}px`;
            }
        },
        watch: {
            el: {
                deep: true,
                handler: function() {
                    this.content = this.el.content;                          
                }
            },
            'el.font.isEdited': function() {             
                if (this.el.font.isEdited === true) {
                    // this.$refs.editableComponent.focus();
                    this.$parent.$parent.$refs.moveable.setState({}, () => {
                        this.$parent.moveable.draggable = false;
                        this.$parent.moveable.pinchable = false;
                        this.$parent.moveable.resizable = false;
                        this.$parent.moveable.rotatable = false;
                        this.$parent.moveable.elementGuidelines =[];
                    })
                } else {
                    if (this.el.placeholder.hasPlaceholder) {
                        const placeholderPayload = {
                            id: this.el.placeholder.placeholderId,
                            content: this.content
                        }
                        this.$store.dispatch('SET_PLACEHOLDER_CONTENT', placeholderPayload);
                    }
                    
                    this.$parent.$parent.$refs.moveable.setState({}, () => {
                        this.$parent.moveable.draggable = true;
                        this.$parent.moveable.pinchable = true;
                        this.$parent.moveable.resizable = true;
                        this.$parent.moveable.rotatable = true;
                        this.$parent.moveable.elementGuidelines = Array.from(document.getElementsByClassName("target"));
                    })
                }
            }
        },
        mounted() {           
            this.content = this.el.content;
        },
        props: ['el']
    }
</script>

<style lang="scss" scoped>
    .editorTextElement {
        height: 100%;
        // overflow: hidden;
        box-sizing: border-box;
        caret-color: #ec7272;
        text-rendering: optimizeLegibility !important;
        font-kerning: none;
        position: relative;

        > div {
            overflow: hidden;
            height: 100%;
        }
        > span {
            position: absolute;
            display: none;
            top: -20px;
            color: #ff4040;
            font-family: 'Roboto', sans-serif;
            font-size: 12px;

            &.visibleError {
                display: block;
            }
        }
    }
    .textCapitals {
        text-transform: uppercase;
    }
    .textUnderline {
        text-decoration: underline;
    }
    textarea {
        width: 100%;
        height: 100%;
        overflow: hidden;
        resize: none;
        border: none;
        background-color: transparent;
    }
    textarea:focus {
        outline: none;
    }
</style>